var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 658.481,
    height: 429.386,
    viewBox: "0 0 658.481 429.386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f3d56;}.b{fill:#ccc;}.c{fill:#ee0a6b;}.d{fill:#e6e6e6;}.e{fill:#f2f2f2;}.f{fill:#fff;}.g{fill:none;}.h{fill:#e50000;}.i{fill:#00b1ff;}.j{fill:#2f2e41;}.k{fill:#6441a4;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-174.583 -1420.025)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.374 28.751)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.209 1403.751)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M354.815,213.32H223.409a1.891,1.891,0,0,0-1.889,1.889v97.138a1.891,1.891,0,0,0,1.889,1.889H354.815a1.891,1.891,0,0,0,1.889-1.889V215.209A1.891,1.891,0,0,0,354.815,213.32Zm1.349,99.027a1.35,1.35,0,0,1-1.349,1.349H223.409a1.35,1.35,0,0,1-1.349-1.349V215.209a1.35,1.35,0,0,1,1.349-1.349H354.815a1.35,1.35,0,0,1,1.349,1.349Z",
    transform: "translate(-221.52 -213.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 134.644,
    height: 0.54,
    transform: "translate(0.27 7.566)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(3.417 2.498)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.619,
    cy: 1.619,
    r: 1.619,
    transform: "translate(7.892 2.428)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.619,
    cy: 1.619,
    r: 1.619,
    transform: "translate(12.547 2.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M522.613,493.228a.27.27,0,0,1-.27-.27V481.895a.27.27,0,0,1,.54,0v11.063A.27.27,0,0,1,522.613,493.228Z",
    transform: "translate(-441.173 -409.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M479.757,440.993a.268.268,0,0,1-.136-.037l-15.33-8.932a.27.27,0,1,1,.272-.466l15.33,8.932a.27.27,0,0,1-.136.5Z",
    transform: "translate(-398.687 -372.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M407.613,440.993a.27.27,0,0,1-.136-.5l15.33-8.932a.27.27,0,0,1,.272.466l-15.33,8.932a.27.27,0,0,1-.135.037Z",
    transform: "translate(-357.203 -372.644)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M538.757,490.993a.269.269,0,0,1-.136-.037l-15.33-8.932a.27.27,0,0,1,.272-.466l15.33,8.932a.27.27,0,0,1-.136.5Z",
    transform: "translate(-441.767 -409.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M466.613,490.993a.27.27,0,0,1-.136-.5l15.33-8.932a.27.27,0,1,1,.272.466l-15.33,8.932a.27.27,0,0,1-.135.037Z",
    transform: "translate(-400.283 -409.153)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M464.545,387.6a.27.27,0,0,1-.27-.269l-.025-9.818a.27.27,0,0,1,.269-.271h0a.27.27,0,0,1,.27.269l.025,9.818a.27.27,0,0,1-.269.27Z",
    transform: "translate(-398.755 -333.008)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M455.968,418.2h-7.03a1.216,1.216,0,0,1-1.214-1.214v-3.611a1.216,1.216,0,0,1,1.214-1.214h7.03a1.216,1.216,0,0,1,1.214,1.214v3.611A1.216,1.216,0,0,1,455.968,418.2Z",
    transform: "translate(-386.688 -358.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M393.951,365.061H378.994a.27.27,0,1,1,0-.54h14.957a.27.27,0,1,1,0,.54Z",
    transform: "translate(-336.306 -323.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M464.52,325.5a.27.27,0,0,1-.27-.27V315.9a.27.27,0,1,1,.54,0v9.34A.27.27,0,0,1,464.52,325.5Z",
    transform: "translate(-398.755 -288.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M318.133,341.771a.269.269,0,0,1-.137-.038l-14.521-8.606a.27.27,0,1,1,.275-.464l14.521,8.607a.27.27,0,0,1-.138.5Z",
    transform: "translate(-281.265 -300.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M303.613,373.667a.27.27,0,0,1-.138-.5L318,364.559a.27.27,0,0,1,.275.464l-14.521,8.606A.269.269,0,0,1,303.613,373.667Z",
    transform: "translate(-281.265 -323.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M362.668,357.057h-3.611a1.216,1.216,0,0,1-1.214-1.214v-7.03a1.216,1.216,0,0,1,1.214-1.214h3.611a1.216,1.216,0,0,1,1.214,1.214v7.03A1.215,1.215,0,0,1,362.668,357.057Z",
    transform: "translate(-321.059 -311.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M455.968,302.973h-7.03a1.216,1.216,0,0,1-1.214-1.214v-3.611a1.216,1.216,0,0,1,1.214-1.214h7.03a1.216,1.216,0,0,1,1.214,1.214v3.611A1.216,1.216,0,0,1,455.968,302.973Z",
    transform: "translate(-386.688 -274.373)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M287.668,326.057h-3.611a1.216,1.216,0,0,1-1.214-1.214v-7.03a1.216,1.216,0,0,1,1.214-1.214h3.611a1.216,1.216,0,0,1,1.214,1.214v7.029A1.216,1.216,0,0,1,287.668,326.057Z",
    transform: "translate(-266.296 -288.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M287.668,389.057h-3.611a1.216,1.216,0,0,1-1.214-1.214v-7.03a1.216,1.216,0,0,1,1.214-1.214h3.611a1.216,1.216,0,0,1,1.214,1.214v7.03A1.216,1.216,0,0,1,287.668,389.057Z",
    transform: "translate(-266.296 -334.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M509.57,365.061H494.613a.27.27,0,1,1,0-.54H509.57a.27.27,0,0,1,0,.54Z",
    transform: "translate(-420.728 -323.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M571.613,341.771a.27.27,0,0,1-.138-.5L586,332.663a.27.27,0,1,1,.275.464l-14.521,8.606A.269.269,0,0,1,571.613,341.771Z",
    transform: "translate(-476.951 -300.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M586.133,373.667a.268.268,0,0,1-.137-.038l-14.521-8.606a.27.27,0,1,1,.275-.464l14.521,8.606a.27.27,0,0,1-.138.5Z",
    transform: "translate(-476.951 -323.723)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M555.1,357.057H551.49a1.216,1.216,0,0,1-1.214-1.214v-7.03a1.216,1.216,0,0,1,1.214-1.214H555.1a1.216,1.216,0,0,1,1.214,1.214v7.03A1.216,1.216,0,0,1,555.1,357.057Z",
    transform: "translate(-461.569 -311.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M630.1,326.057H626.49a1.216,1.216,0,0,1-1.214-1.214v-7.03a1.216,1.216,0,0,1,1.214-1.214H630.1a1.216,1.216,0,0,1,1.214,1.214v7.029A1.216,1.216,0,0,1,630.1,326.057Z",
    transform: "translate(-516.332 -288.731)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M630.1,389.057H626.49a1.216,1.216,0,0,1-1.214-1.214v-7.03a1.216,1.216,0,0,1,1.214-1.214H630.1a1.216,1.216,0,0,1,1.214,1.214v7.03A1.216,1.216,0,0,1,630.1,389.057Z",
    transform: "translate(-516.332 -334.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M397.968,469.2h-7.03a1.216,1.216,0,0,1-1.214-1.214v-3.611a1.216,1.216,0,0,1,1.214-1.214h7.03a1.216,1.216,0,0,1,1.214,1.214v3.611A1.216,1.216,0,0,1,397.968,469.2Z",
    transform: "translate(-344.338 -395.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M513.783,469.2h-7.03a1.216,1.216,0,0,1-1.214-1.214v-3.611a1.216,1.216,0,0,1,1.214-1.214h7.03A1.216,1.216,0,0,1,515,464.373v3.611A1.216,1.216,0,0,1,513.783,469.2Z",
    transform: "translate(-428.903 -395.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M460.783,518.2h-7.03a1.216,1.216,0,0,1-1.214-1.214v-3.611a1.216,1.216,0,0,1,1.214-1.214h7.03A1.216,1.216,0,0,1,462,513.373v3.611A1.215,1.215,0,0,1,460.783,518.2Z",
    transform: "translate(-390.204 -431.524)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M571.783,518.2h-7.03a1.216,1.216,0,0,1-1.214-1.214v-3.611a1.216,1.216,0,0,1,1.214-1.214h7.03A1.216,1.216,0,0,1,573,513.373v3.611A1.215,1.215,0,0,1,571.783,518.2Z",
    transform: "translate(-471.253 -431.524)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M513.783,518.2h-7.03a1.215,1.215,0,0,1-1.214-1.214v-3.611a1.216,1.216,0,0,1,1.214-1.214h7.03A1.216,1.216,0,0,1,515,513.373v3.611A1.215,1.215,0,0,1,513.783,518.2Z",
    transform: "translate(-428.903 -431.524)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M447.386,357.513H430.3a1.216,1.216,0,0,1-1.214-1.214v-6.959a1.216,1.216,0,0,1,1.214-1.214h17.09a1.216,1.216,0,0,1,1.214,1.214V356.3A1.216,1.216,0,0,1,447.386,357.513Z",
    transform: "translate(-373.075 -311.751)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(391.584 1403.986)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M413.106,424.729a.555.555,0,0,1-.541-.435A177.671,177.671,0,0,1,470.55,250.768a.555.555,0,1,1,.722.843,176.563,176.563,0,0,0-57.624,172.445.554.554,0,0,1-.542.674Z",
    transform: "translate(-408.34 -181.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M700.917,496.97a91.474,91.474,0,0,1-89.146-71.607,73.246,73.246,0,0,1,55.638-87.235,58.641,58.641,0,0,1,69.92,44.595,47.077,47.077,0,0,1-35.76,56.068,37.923,37.923,0,0,1-42.417-21.037.555.555,0,1,1,1.008-.464,36.8,36.8,0,0,0,41.17,20.417,45.966,45.966,0,0,0,34.917-54.746,57.532,57.532,0,0,0-68.6-43.751,72.135,72.135,0,0,0-54.794,85.912,90.307,90.307,0,0,0,107.556,68.6,112.742,112.742,0,0,0,75.582-57.753.555.555,0,1,1,.982.516,113.849,113.849,0,0,1-76.324,58.321,91.325,91.325,0,0,1-19.733,2.165Z",
    transform: "translate(-498.144 -219.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M853.058,300.242a.555.555,0,0,1-.551-.5,114.62,114.62,0,0,0-2.044-12.477c-14.489-65.513-73.616-112.119-140.593-110.757a.555.555,0,0,1-.022-1.11,142.416,142.416,0,0,1,141.7,111.628,115.753,115.753,0,0,1,2.064,12.6.555.555,0,0,1-.492.611A.57.57,0,0,1,853.058,300.242Z",
    transform: "translate(-542.343 -147.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M616.277,214.586H529.735a9.441,9.441,0,0,1-9.431-9.431V134.7a9.442,9.442,0,0,1,9.431-9.431h86.542a9.442,9.442,0,0,1,9.431,9.431v70.454a9.442,9.442,0,0,1-9.431,9.431Zm-86.542-88.206a8.331,8.331,0,0,0-8.321,8.321v70.454a8.331,8.331,0,0,0,8.321,8.321h86.542a8.331,8.331,0,0,0,8.321-8.321V134.7a8.331,8.331,0,0,0-8.321-8.321Z",
    transform: "translate(-458.191 -125.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M639.28,161.066H595.6a1.515,1.515,0,0,1-1.54-1.381,1.46,1.46,0,0,1,1.457-1.538h44.46c1.465,1.287.572,2.919-.7,2.919Z",
    transform: "translate(-491.032 -139.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M639.28,174.875H595.6a1.515,1.515,0,0,1-1.54-1.381,1.46,1.46,0,0,1,1.457-1.538h44.46c1.465,1.287.572,2.919-.7,2.919Z",
    transform: "translate(-491.032 -146.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M567.805,169.82h-13.33a1.643,1.643,0,0,1-1.641-1.642v-15.73a1.643,1.643,0,0,1,1.641-1.642h13.33a1.644,1.644,0,0,1,1.642,1.641v15.73A1.643,1.643,0,0,1,567.805,169.82Z",
    transform: "translate(-472.675 -136.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M620.606,203.151H553.948a1.515,1.515,0,0,1-1.54-1.381,1.459,1.459,0,0,1,1.457-1.538h67.442c1.465,1.287.572,2.919-.7,2.919Z",
    transform: "translate(-472.485 -158.646)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M620.606,216.965H553.948a1.515,1.515,0,0,1-1.54-1.381,1.459,1.459,0,0,1,1.457-1.538h67.442c1.465,1.287.572,2.919-.7,2.919Z",
    transform: "translate(-472.485 -164.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M620.606,230.77H553.948a1.515,1.515,0,0,1-1.54-1.381,1.459,1.459,0,0,1,1.457-1.538h67.442c1.465,1.287.572,2.919-.7,2.919Z",
    transform: "translate(-472.485 -170.944)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M620.606,244.583H553.948a1.515,1.515,0,0,1-1.54-1.381,1.459,1.459,0,0,1,1.457-1.538h67.442c1.465,1.287.572,2.919-.7,2.919Z",
    transform: "translate(-472.485 -177.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M620.606,258.39H553.948a1.515,1.515,0,0,1-1.54-1.381,1.459,1.459,0,0,1,1.457-1.538h67.442c1.465,1.287.572,2.919-.7,2.919Z",
    transform: "translate(-472.485 -183.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M957.56,464.265H894.875a7.394,7.394,0,0,1-7.386-7.386V405.844a7.394,7.394,0,0,1,7.386-7.386h62.687a7.394,7.394,0,0,1,7.386,7.386v51.034A7.394,7.394,0,0,1,957.56,464.265Zm-62.686-64.7a6.283,6.283,0,0,0-6.276,6.276v51.034a6.283,6.283,0,0,0,6.277,6.277h62.687a6.284,6.284,0,0,0,6.277-6.277V405.844a6.284,6.284,0,0,0-6.277-6.276Z",
    transform: "translate(-621.679 -246.906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M974.671,425.387H943.034a1.1,1.1,0,0,1-1.115-1,1.057,1.057,0,0,1,1.056-1.114h32.208c1.061.932.414,2.114-.508,2.114Z",
    transform: "translate(-645.912 -257.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M974.671,435.391H943.034a1.1,1.1,0,0,1-1.116-1,1.057,1.057,0,0,1,1.055-1.114h32.205c1.061.932.414,2.114-.508,2.114Z",
    transform: "translate(-645.912 -262.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M922.9,431.73h-9.655a1.19,1.19,0,0,1-1.189-1.189V419.147a1.19,1.19,0,0,1,1.189-1.189H922.9a1.191,1.191,0,0,1,1.189,1.189v11.394a1.19,1.19,0,0,1-1.189,1.189Z",
    transform: "translate(-632.616 -255.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M961.14,455.873H912.856a1.1,1.1,0,0,1-1.115-1,1.057,1.057,0,0,1,1.055-1.114h48.853c1.061.932.414,2.114-.508,2.114Z",
    transform: "translate(-632.476 -271.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M961.14,465.879H912.856a1.1,1.1,0,0,1-1.115-1,1.057,1.057,0,0,1,1.055-1.114h48.853c1.061.932.414,2.114-.508,2.114Z",
    transform: "translate(-632.476 -275.983)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M961.142,475.879H912.86a1.1,1.1,0,0,1-1.115-1,1.057,1.057,0,0,1,1.055-1.114h48.853c1.061.932.414,2.114-.508,2.114Z",
    transform: "translate(-632.478 -280.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M961.14,485.884H912.856a1.1,1.1,0,0,1-1.115-1,1.057,1.057,0,0,1,1.055-1.114h48.853c1.061.932.414,2.114-.508,2.114Z",
    transform: "translate(-632.476 -284.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M961.142,495.885H912.86a1.1,1.1,0,0,1-1.115-1,1.057,1.057,0,0,1,1.055-1.114h48.853c1.061.932.414,2.114-.508,2.114Z",
    transform: "translate(-632.478 -289.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M700.3,449.927H660.561a4.891,4.891,0,0,1-4.886-4.886V412.687a4.891,4.891,0,0,1,4.886-4.886H700.3a4.891,4.891,0,0,1,4.886,4.886v32.355A4.891,4.891,0,0,1,700.3,449.927ZM660.561,408.91a3.78,3.78,0,0,0-3.776,3.776v32.355a3.781,3.781,0,0,0,3.776,3.776H700.3a3.781,3.781,0,0,0,3.776-3.776V412.687a3.781,3.781,0,0,0-3.776-3.776Z",
    transform: "translate(-518.465 -251.065)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M700.983,448.013H673.8a2.5,2.5,0,0,1,0-4.993h27.183a2.5,2.5,0,0,1,0,4.993Z",
    transform: "translate(-525.423 -266.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M699.888,429.513H683.8a2.5,2.5,0,0,1,0-4.993h16.088a2.5,2.5,0,1,1,0,4.993Z",
    transform: "translate(-529.876 -258.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M700.983,463.013H673.8a2.5,2.5,0,0,1,0-4.993h27.183a2.5,2.5,0,1,1,0,4.993Z",
    transform: "translate(-525.423 -273.425)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 7.767,
    cy: 7.767,
    r: 7.767,
    transform: "translate(8.094 124.924)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 7.767,
    cy: 7.767,
    r: 7.767,
    transform: "translate(254.96 56.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 7.767,
    cy: 7.767,
    r: 7.767,
    transform: "translate(257.96 245.69)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 7.767,
    cy: 7.767,
    r: 7.767,
    transform: "translate(170.083 266.387)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.126 1496.875)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M663.815,146.935H427.475a3.4,3.4,0,0,0-3.4,3.4v85.429h57.2a5.847,5.847,0,0,1,5.84,5.84v72.276h176.7a3.392,3.392,0,0,0,2.582-1.192.8.8,0,0,0,.074-.093,3.179,3.179,0,0,0,.487-.822,3.314,3.314,0,0,0,.257-1.289V150.33a3.4,3.4,0,0,0-3.4-3.4Z",
    transform: "translate(-367.974 -146.935)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 242.163,
    height: 0.971,
    transform: "translate(56.589 13.608)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.912,
    cy: 2.912,
    r: 2.912,
    transform: "translate(61.928 4.368)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.912,
    cy: 2.912,
    r: 2.912,
    transform: "translate(70.299 4.368)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 2.912,
    cy: 2.912,
    r: 2.912,
    transform: "translate(78.67 4.368)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M693.84,236.315H572.361a5.062,5.062,0,0,0,0,10.123H693.84a5.062,5.062,0,1,0,0-10.123Zm0,9.345H572.361a4.283,4.283,0,1,1,0-8.566H693.84a4.283,4.283,0,0,1,0,8.566Z",
    transform: "translate(-455.43 -201.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M789.311,387.885H667.832a5.062,5.062,0,0,0,0,10.123H789.311a5.062,5.062,0,0,0,0-10.123Z",
    transform: "translate(-513.728 -294.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M789.311,435.885H667.832a5.062,5.062,0,1,0,0,10.123H789.311a5.062,5.062,0,1,0,0-10.123Z",
    transform: "translate(-513.728 -323.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M531.61,318.385h-55.3a4.479,4.479,0,0,0-4.474,4.474v17.6h.779v-17.6a3.7,3.7,0,0,1,3.7-3.695h55.3a3.7,3.7,0,0,1,3.695,3.695v55.3a3.7,3.7,0,0,1-3.695,3.695H516.281v.779H531.61a4.476,4.476,0,0,0,4.473-4.474v-55.3A4.476,4.476,0,0,0,531.61,318.385Z",
    transform: "translate(-397.138 -251.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M393.283,373.065H286.6a6.628,6.628,0,0,0-6.619,6.619V514.4a6.628,6.628,0,0,0,6.619,6.619H393.283A6.628,6.628,0,0,0,399.9,514.4V379.684A6.629,6.629,0,0,0,393.283,373.065Zm5.84,141.336a5.848,5.848,0,0,1-5.84,5.84H286.6a5.847,5.847,0,0,1-5.84-5.84V379.684a5.847,5.847,0,0,1,5.84-5.84H393.283a5.847,5.847,0,0,1,5.84,5.84Z",
    transform: "translate(-279.98 -285.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M407.831,596.688H343.2c-6.6-.032-6.63-10.089,0-10.123h64.633C414.429,586.6,414.465,596.654,407.831,596.688Z",
    transform: "translate(-315.554 -415.392)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M407.831,644.688H343.2c-6.6-.032-6.63-10.089,0-10.123h64.633C414.429,634.6,414.465,644.654,407.831,644.688Z",
    transform: "translate(-315.554 -444.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M407.831,692.688H343.2c-6.6-.032-6.63-10.089,0-10.123h64.633C414.429,682.6,414.465,692.653,407.831,692.688Z",
    transform: "translate(-315.554 -474.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M563.1,373.312a10.123,10.123,0,1,1,10.123-10.123A10.123,10.123,0,0,1,563.1,373.312Z",
    transform: "translate(-446.686 -272.807)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M575.714,369.821h-4.283v-4.867a.389.389,0,1,0-.779,0v4.867h-4.283a.389.389,0,0,0,0,.779h4.283v4.867a.389.389,0,0,0,.779,0V370.6h4.283a.389.389,0,1,0,0-.779Z",
    transform: "translate(-454.624 -279.829)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M406.2,480.5H343.9a6.432,6.432,0,0,1-6.424-6.424V439.189a6.432,6.432,0,0,1,6.424-6.424h62.3a6.432,6.432,0,0,1,6.424,6.424v34.886A6.432,6.432,0,0,1,406.2,480.5Z",
    transform: "translate(-315.092 -321.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M789.311,339.885H667.832a5.062,5.062,0,1,0,0,10.123H789.311a5.062,5.062,0,1,0,0-10.123Z",
    transform: "translate(-513.728 -264.759)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525.879 1706.142)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M42,22.641A5.4,5.4,0,0,0,38,24.9V14.338H33.45V47.147H38v-1.86a5.164,5.164,0,0,0,4.278,2.172c2.991,0,4.114-2.329,4.114-5.327V28.7C46.388,25.423,45.294,22.641,42,22.641Zm-.245,18.837a2.832,2.832,0,0,1-.387,1.667,1.93,1.93,0,0,1-2.306.253A3.929,3.929,0,0,1,38,42.535V27.462a3.548,3.548,0,0,1,.93-.744,1.863,1.863,0,0,1,2.344.4,3.048,3.048,0,0,1,.484,1.86Z",
    transform: "translate(5.735 34.018)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M39.474,33.864c-.543.692-1.763,1.808-2.641,1.808-.96,0-1.205-.647-1.205-1.622V15.495H31.134V35.724c0,4.9,3.326,4.94,5.751,3.549a9.752,9.752,0,0,0,2.589-2.247V39.7h4.508v-24.2H39.474Z",
    transform: "translate(-9.179 41.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M44.606,14.338H29.051V19.1H34.3V47.152h5.064V19.1h5.246Z",
    transform: "translate(-22.593 34.017)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M34.59,26.331c1.272,0,1.979-1.027,1.979-2.41V12.1c0-1.421-.625-2.425-2.076-2.425-1.332,0-1.964,1.034-1.964,2.425V23.92A2.145,2.145,0,0,0,34.59,26.331Z",
    transform: "translate(-0.196 3.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M42.482,15.412c-4.062,0-6.837,2.916-6.837,7.127V33.4c0,4.352,2.2,7.484,6.495,7.484,4.747,0,6.74-2.827,6.74-7.484V31.579H44.253V33.26c0,2.105-.119,3.385-2.016,3.385-1.808,0-1.964-1.57-1.964-3.385V28.7H48.88v-6.16C48.88,18.165,46.8,15.412,42.482,15.412Zm1.771,9.53h-3.98V22.495c0-1.667.35-2.842,2.009-2.842,1.622,0,1.972,1.205,1.972,2.842Z",
    transform: "translate(19.871 40.934)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M31.875,28.309c0,4.479,2.344,6.815,6.926,6.815a6.475,6.475,0,0,0,6.793-6.815V15.847A6.633,6.633,0,0,0,38.8,9.025c-4.166,0-6.926,2.753-6.926,6.822Zm4.866-12.038c0-1.391.632-2.425,1.964-2.425,1.451,0,2.076,1,2.076,2.425V28.093c0,1.384-.707,2.41-1.979,2.41a2.145,2.145,0,0,1-2.061-2.41Z",
    transform: "translate(-4.407 -0.196)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M37.554,34.839c1.436,0,3.415-.751,5.468-3.177v2.8h4.724V9.053H43.022V28.344c-.573.722-1.86,1.9-2.782,1.9-1,0-1.257-.692-1.257-1.719V9.053H34.258V30.3C34.258,32.8,35.024,34.839,37.554,34.839Z",
    transform: "translate(10.939 -0.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M38.276,15.982c-1.659,0-2.009,1.175-2.009,2.842v2.448h3.98V18.824C40.247,17.187,39.9,15.982,38.276,15.982Z",
    transform: "translate(23.876 44.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M35.838,42.291h5.325V28.315l6.19-20.477H41.947L38.539,21.61,34.871,7.838H29.509l6.329,20.477Z",
    transform: "translate(-19.644 -7.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M90.8,13.835c-9.679-.662-41.164-.662-50.836,0-10.46.714-11.7,7.038-11.777,23.681.082,16.62,1.3,22.967,11.777,23.688,9.672.662,41.157.662,50.836,0,10.468-.722,11.7-7.038,11.785-23.688C102.5,20.9,101.279,14.549,90.8,13.835ZM44.952,53.586H39.886V25.538H34.641V20.776H50.2v4.761H44.952Zm18.034,0H58.478V50.915a9.752,9.752,0,0,1-2.589,2.247c-2.425,1.391-5.751,1.354-5.751-3.549V29.384h4.494V47.939c0,.975.246,1.622,1.205,1.622.878,0,2.1-1.116,2.641-1.808V29.384h4.508Zm17.32-5.014c0,3-1.123,5.327-4.114,5.327a5.164,5.164,0,0,1-4.278-2.172v1.86H67.368V20.776h4.546V31.333a5.4,5.4,0,0,1,4-2.254c3.3,0,4.389,2.782,4.389,6.063Zm16.628-6.517H88.326v4.561c0,1.815.156,3.385,1.964,3.385,1.9,0,2.016-1.28,2.016-3.385V44.933h4.628v1.823c0,4.657-1.994,7.484-6.74,7.484-4.293,0-6.495-3.132-6.495-7.484V35.894c0-4.211,2.775-7.127,6.837-7.127,4.315,0,6.4,2.753,6.4,7.127Z",
    transform: "translate(-28.183 27.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M34.991,16.207a3.547,3.547,0,0,0-.93.744V32.024a3.929,3.929,0,0,0,1.064.863,1.93,1.93,0,0,0,2.306-.253,2.832,2.832,0,0,0,.387-1.667v-12.5a3.048,3.048,0,0,0-.484-1.86A1.863,1.863,0,0,0,34.991,16.207Z",
    transform: "translate(9.67 44.529)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M77.927,14.5a29.331,29.331,0,0,1-8.416,2.309A14.719,14.719,0,0,0,75.957,8.7a29.162,29.162,0,0,1-9.315,3.553,14.662,14.662,0,0,0-24.97,13.369,41.622,41.622,0,0,1-30.2-15.309,14.675,14.675,0,0,0,4.536,19.565,14.631,14.631,0,0,1-6.637-1.833A14.661,14.661,0,0,0,21.125,42.593a14.685,14.685,0,0,1-6.619.256A14.68,14.68,0,0,0,28.19,53.027,29.5,29.5,0,0,1,6.5,59.092a41.451,41.451,0,0,0,22.458,6.589c27.22,0,42.588-22.988,41.654-43.6A29.542,29.542,0,0,0,77.927,14.5Z",
    transform: "translate(662.653 1383.651)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.539 1631.996)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M862.745,268.164a117.225,117.225,0,0,1-15.193,29.14c-.148.208-.3.412-.449.619l-19.441-6.3c.088-.2.184-.426.286-.671,6.123-14.482,42.969-102.76,39.056-121.165C867.379,171.3,879.587,221.3,862.745,268.164Z",
    transform: "translate(-614.884 -169.791)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M867.712,431.829c-.237.179-.482.356-.729.528L852.4,427.634c.174-.161.377-.351.611-.566,3.818-3.568,15.159-14.26,26.144-25.594,11.8-12.18,23.2-25.1,24.412-30.719C903.338,372.038,896.146,411.041,867.712,431.829Z",
    transform: "translate(-631.293 -303.102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M454,698.125H203.994a8.383,8.383,0,0,1-8.383-8.383h0q135.941-15.8,266.771,0h0A8.383,8.383,0,0,1,454,698.125Z",
    transform: "translate(-195.611 -509.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M462.382,356.006l-266.771-.493,30.918-52.023.148-.246V188.591a10.6,10.6,0,0,1,10.6-10.6H419.24a10.6,10.6,0,0,1,10.6,10.6v115.44Z",
    transform: "translate(-195.611 -175.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M311.849,199.966a3.456,3.456,0,0,0-3.452,3.452V307.956a3.456,3.456,0,0,0,3.452,3.452H495.778a3.456,3.456,0,0,0,3.452-3.452V203.417a3.456,3.456,0,0,0-3.452-3.452Z",
    transform: "translate(-270.428 -189.807)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M300.554,572.015a1.483,1.483,0,0,0-1.344.861l-9.527,20.711a1.479,1.479,0,0,0,1.344,2.1H491.369a1.479,1.479,0,0,0,1.323-2.141l-10.355-20.711a1.472,1.472,0,0,0-1.323-.818Z",
    transform: "translate(-257.924 -436.607)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 2.219,
    cy: 2.219,
    r: 2.219,
    transform: "translate(130.427 3.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M523.513,654.042a1.481,1.481,0,0,0-1.428,1.094l-2.39,8.876a1.479,1.479,0,0,0,1.428,1.864H566.57a1.479,1.479,0,0,0,1.4-1.963l-3.072-8.876a1.48,1.48,0,0,0-1.4-1Z",
    transform: "translate(-410.559 -491.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M295.148,375.126V377.1H91.84l.153-.246v-1.726Z",
    transform: "translate(-60.922 -248.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M541.316,254.83H493.347v.876h47.969a8.9,8.9,0,0,1,0,17.809H468.73a8.9,8.9,0,0,1,0-17.809h2.712v-.876H468.73a9.781,9.781,0,1,0,0,19.562h72.585a9.781,9.781,0,1,0,0-19.562Z",
    transform: "translate(-370.297 -226.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M541.316,344.619H493.347v.876h47.969a8.9,8.9,0,0,1,0,17.809H468.73a8.9,8.9,0,1,1,0-17.809h2.712v-.876H468.73a9.781,9.781,0,1,0,0,19.562h72.585a9.781,9.781,0,1,0,0-19.562Z",
    transform: "translate(-370.297 -285.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M541.316,434.407H493.347v.876h47.969a8.9,8.9,0,0,1,0,17.809H468.73a8.9,8.9,0,1,1,0-17.809h2.712v-.876H468.73a9.781,9.781,0,1,0,0,19.562h72.585a9.781,9.781,0,0,0,0-19.562Z",
    transform: "translate(-370.297 -345.325)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M507.011,247.953a2.6,2.6,0,1,0,0,5.21h11.428a2.605,2.605,0,0,0,.086-5.21H507.011Z",
    transform: "translate(-400.451 -221.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M507.011,339.043a2.6,2.6,0,1,0,0,5.21h11.428a2.605,2.605,0,0,0,.086-5.21H507.011Z",
    transform: "translate(-400.451 -282.065)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M507.011,427.531a2.6,2.6,0,1,0,0,5.21h11.427a2.605,2.605,0,0,0,.086-5.21H507.011Z",
    transform: "translate(-400.451 -340.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M493.547,276.145a2.6,2.6,0,1,0,0,5.21h65.311a2.605,2.605,0,1,0,.086-5.21h-65.4Z",
    transform: "translate(-391.519 -240.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M493.547,365.934a2.6,2.6,0,1,0,0,5.21h65.311a2.605,2.605,0,1,0,.086-5.21h-65.4Z",
    transform: "translate(-391.519 -299.903)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M493.547,455.722a2.6,2.6,0,1,0,0,5.21h65.311a2.605,2.605,0,0,0,.086-5.21h-65.4Z",
    transform: "translate(-391.519 -359.464)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 5.216,
    cy: 5.216,
    r: 5.216,
    transform: "translate(72.554 32.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M226.583,111.411l-1.52-1.954.884-.687.72.925,2.431-2.566.813.77Z",
    transform: "translate(-149.296 -71.064)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 5.216,
    cy: 5.216,
    r: 5.216,
    transform: "translate(72.554 63.215)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M226.583,201.2l-1.52-1.954.884-.687.72.925,2.431-2.566.813.77Z",
    transform: "translate(-149.296 -130.626)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 5.216,
    cy: 5.216,
    r: 5.216,
    transform: "translate(72.554 93.441)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 5.216,
    cy: 5.216,
    r: 5.216,
    transform: "translate(186.891 32.987)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 5.216,
    cy: 5.216,
    r: 5.216,
    transform: "translate(186.891 63.215)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 5.216,
    cy: 5.216,
    r: 5.216,
    transform: "translate(186.891 93.441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M226.583,290.989l-1.52-1.954.884-.687.72.925,2.431-2.566.813.77Z",
    transform: "translate(-149.296 -190.188)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 0.614,
    height: 4.125,
    transform: "translate(190.357 36.962) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 4.125,
    height: 0.614,
    transform: "translate(190.51 39.445) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 0.614,
    height: 4.125,
    transform: "translate(190.357 67.189) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 4.125,
    height: 0.614,
    transform: "translate(190.51 69.672) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 0.614,
    height: 4.125,
    transform: "translate(190.357 97.416) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 4.125,
    height: 0.614,
    transform: "translate(190.51 99.899) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M814.974,558.338a.361.361,0,0,0-.348.267l-.582,2.161a.36.36,0,0,0,.348.454h11.067a.36.36,0,0,0,.34-.478l-.748-2.161a.36.36,0,0,0-.34-.242Z",
    transform: "translate(-605.842 -427.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M766.974,558.338a.361.361,0,0,0-.348.267l-.582,2.161a.36.36,0,0,0,.348.454h11.067a.36.36,0,0,0,.34-.478l-.748-2.161a.36.36,0,0,0-.34-.242Z",
    transform: "translate(-574.001 -427.535)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M138.587,79.7l-1.562,5.076.039,23.429h5.818v3.124h3.124l3.124-3.124H154.6l10.153-10.153V79.7Zm23.429,16.791-4.3,4.3h-7.029l-3.9,3.9v-3.9H140.93V82.433h21.086Zm-7.029-8.981h2.733v7.81h-2.733Zm-7.029,0h2.733v7.81h-2.733Zm33.191,36.315v18.353L171,149.206h-6.248v-3.124l-4.686,3.124H154.6v-3.124l-3.514,3.124H140.93l-3.124-3.124-.781,3.124-8.942-.039-3.553-3.085-.39,3.124-10.153-.039-.39-3.085-2.733,3.085-15.619.039-3.124-1.562v1.562H83.529l-9.372-5.857L68.3,137.491V111.72H80.4l5.857,5.857h26.553V111.72h21.867v5.857h5.467V120.7l3.124-3.124h6.638l5.857-5.857h12.5v5.857H174.9ZM83.529,120.31H78.062v-5.857H71.033V136.32l4.3,4.686h8.2v-7.419H78.062v-6.248h5.467Zm29.286,0h-7.029v13.276h-2.733V120.31H96.415v13.276H93.681V120.31H86.262v20.7h21.867l4.686-4.686Zm9.372,0h-6.638v20.7h6.638Zm0-5.857h-6.638v3.124h6.638Zm15.229,5.857h-5.467v-5.857H124.92V136.32l4.3,4.686h8.2v-7.419h-5.467v-6.248h5.467Zm17.962,0H144.444l-4.3,4.3V136.32l4.686,4.686h10.543v-7.419h-7.81v-6.248h7.81Zm23.038,4.3-4.686-4.3h-8.2v-5.857h-7.419v26.553h7.419V127.339H171v13.667h7.419Z",
    transform: "translate(651.915 1606.274)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImage);
export default __webpack_public_path__ + "static/media/about_Image.dbffc31783594ee1a051a27b879b8439.svg";
export { ForwardRef as ReactComponent };